import iconUrl from '@/assets/brand/zafroi_logo.png';
import { cn } from '@zafroi/ui-kit';

// Mirror of zafroi-erp-app's Logo so both apps render an identical brand
// lockup in the sidebar header. PNG assets live in public/brand/ on each
// app (copied to keep deploys self-contained). Eventually the Logo +
// assets should move into @zafroi/ui-kit so the kit is the single source
// — tracked under "Platform shell unification" in docs/BACKLOG.md.

// Cropped wordmark (1230×410, 3:1) lives in public/. Base-aware so it resolves
// under the workspace path build (app.zafroi.com/engage/brand/…) too (ADR-023).
const NAME_URL = `${import.meta.env.BASE_URL}brand/zafroi-name.png`;

interface Props {
  variant?: 'mark' | 'lockup';
  className?: string;
  iconClassName?: string;
  nameClassName?: string;
  /** Tagline shown beside the wordmark in the lockup. */
  tagline?: string;
  taglineClassName?: string;
  /** Adds a subtle saffron drop shadow — useful on dark surfaces. */
  glow?: boolean;
}

export function Logo({
  variant = 'lockup',
  className,
  iconClassName,
  nameClassName,
  tagline = 'Engage',
  taglineClassName,
  glow,
}: Props) {
  if (variant === 'mark') {
    return (
      <img
        src={iconUrl}
        alt="Zafroi"
        className={cn(
          'h-9 w-9 select-none',
          glow && 'drop-shadow-[0_2px_8px_rgba(255,122,26,0.35)]',
          className,
          iconClassName,
        )}
        draggable={false}
      />
    );
  }

  return (
    <span className={cn('inline-flex items-center gap-2 leading-none', className)}>
      <img
        src={NAME_URL}
        alt="Zafroi"
        className={cn(
          'h-7 w-auto select-none',
          glow && 'drop-shadow-[0_2px_10px_rgba(255,122,26,0.40)]',
          nameClassName,
        )}
        draggable={false}
      />
      {tagline && (
        <>
          {/* Divider + tagline both render in saffron/orange (theme's
              --primary) so the brand color carries all the way through
              the lockup — "Zafroi | ENGAGE" reads as one unified mark. */}
          <span aria-hidden="true" className="h-5 w-px bg-primary/70" />
          <span
            className={cn(
              'text-[11px] font-bold uppercase tracking-[0.22em] text-primary',
              taglineClassName,
            )}
          >
            {tagline}
          </span>
        </>
      )}
    </span>
  );
}
